import React from "react";
export const MenuIcon = ({ overideStyle = {}, fillColor = "white" }) => {
    return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={overideStyle}>
			<path d="M3.5 5.5C2.94772 5.5 2.5 5.94772 2.5 6.5C2.5 7.05228 2.94772 7.5 3.5 7.5H12.5C13.0523 7.5 13.5 7.05228 13.5 6.5C13.5 5.94772 13.0523 5.5 12.5 5.5H3.5Z" fill={fillColor}/>
			<path d="M3.5 11C2.94772 11 2.5 11.4477 2.5 12C2.5 12.5523 2.94772 13 3.5 13H20.5C21.0523 13 21.5 12.5523 21.5 12C21.5 11.4477 21.0523 11 20.5 11H3.5Z" fill={fillColor}/>
			<path d="M3.5 16.5C2.94772 16.5 2.5 16.9477 2.5 17.5C2.5 18.0523 2.94772 18.5 3.5 18.5H15.5C16.0523 18.5 16.5 18.0523 16.5 17.5C16.5 16.9477 16.0523 16.5 15.5 16.5H3.5Z" fill={fillColor}/>
		</svg>);
};
